import script from "./DictionaryRoomModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./DictionaryRoomModal.vue?vue&type=script&lang=ts&setup=true"

import "./DictionaryRoomModal.vue?vue&type=style&index=0&id=39f7238e&lang=scss"

const __exports__ = script;

export default __exports__